export enum ApiModule {
	AUTH = 'auth',
	CLIENT = 'client',
	EMPLOYEE = 'employee',
	DIETARY = 'dietary',
	ORDER = 'order',
	SYSTEM = 'system',
	SUPPLIER = 'suppliers',
	PRODUCTION_PLANNING = 'production-planning',
	DEMAND_PLANNING = 'demand-planning',
	PURCHASE = 'purchase',
	INBOUND_DELIVERY = 'inbound-delivery',
	WAREHOUSE = 'warehouse',
}

export enum ApiAuthorization {
	EMPLOYEE = 'employee',
	CLIENT = 'client',
	PUBLIC = 'public',
}

export enum ApiDataModel {
	//auth
	INVITATIONS = 'invitations',
	EMPLOYEE = 'employee',
	CLIENT = 'client',
	PASSWORD_RESET = 'password-reset',

	//users
	CLIENTS = 'clients',
	EMPLOYEES = 'employees',
	ACITVITY_LOGS = 'activity-logs',
	ROLES = 'roles',
	PERMISSIONS = 'permissions',
	ACCOUNT_STATUS = 'accountStatus',

	//employees
	TEAMS = 'teams',
	LOCATIONS = 'locations',
	TABLET_WORKERS = 'tablet-workers',

	//diets
	DIETARY = 'dietary',
	ALLERGENS = 'allergens',
	MEAL = 'meal',
	MEAL_SIZE = 'meal-size',
	MEAL_VARIANT = 'variant',
	MEAL_VARIANTS = 'variants',
	MEALPREPS = 'mealpreps',
	SEMI_PRODUCT = 'semi-product',
	SEMI_PRODUCTS = 'semi-products',
	SEMI_PRODUCT_SOCKET_ASSIGNMENTS = 'semi-product-socket-assignments',
	MATERIALS = 'raw-material',
	MATERIALS_CATEGORY = 'raw-material-category',
	MEAL_PACKAGING = 'meal-packaging-types',
	NUTRITIONAL_PARAMETER = 'nutritional-parameters',
	FOOD_PRODUCTION_STAGE = 'food-production-stage',
	PRICE_TIER = 'meal-price-tier',
	DIET = 'diet',
	DIET_DAYS = 'diet-days',
	COMPONENTS = 'components',
	FILTER_TAGS = 'filter-tags',
	MARKETING_TAGS = 'marketing-tags',
	DIETARY_TAGS = 'dietary-tags',
	ADDONS = 'addons',
	ADDONS_CATEGORIES = 'addons-categories',
	SIZE_MATRICES = 'meal-size-matrices',

	//orders
	ORDER = 'order',
	CARTS = 'carts',
	TRANSACTIONS = 'transactions',
	CLIENT_DIET_DAYS = 'client-diet-days',

	DIETS = 'diets',
	CLIENT_DIETS = 'client-diets',
	MEDIA = 'media',
	PRICES = 'prices',
	RATINGS = 'client-meal-ratings',

	ADDRESS = 'address',
	SCHEDULE = 'operations-schedule',
	SCHEDULE_BLACKLIST = 'operations-schedule-days-blacklist',
	PRODUCTION_ORDERS = 'production-orders',

	// Loyalty, points
	LOYALTY_ACTIVITIES = 'loyalty-activities',
	LOYALTY_ACTIONS = 'loyalty-actions',
	LOYALTY_RULES = 'loyalty-rules',
	LOYALTY_TRANSACTIONS = 'loyalty-transactions',
	LOYALTY_POINTS = 'loyalty-points',
	LOYALTY_LEVELS = 'loyalty-levels',

	//promotions, codes, discounts
	PROMOTIONS = 'promotions',
	PROMOTION_ACTIONS = 'promotion-actions',
	PROMOTION_RULES = 'promotion-rules',
	COUPONS = 'coupons',

	MESSAGE = 'client-messages',

	//production
	PRODUCTION_PLANS = 'production-plans',
	PRODUCTION_STAGES = 'production-stages',
	CRM = 'crm',
	PRODUCTION_SOCKETS = 'production-sockets',
	SIMULATIONS = 'simulations',
	PRODUCTION_MEALS = 'production-meals',
	PRODUCTION_MACHINES = 'production-machines',
	FACILITIES = 'facilities',
	FACILITY_ASSIGNMENT_PLAN = 'facility-assignment-plan',
	DEMAND_ORDERS = 'demand-orders',

	//suppliers
	LIST = 'list',
	ADD = 'add',
	ACTIVE = 'active',
	INACTIVE = 'inactive',
	SEARCH = 'search',

	// purchase
	PURCHASE_ORDERS = 'purchase-orders',
	ORDERS = 'orders',

	// warehouse
	MAPPING = 'mapping',
	MES_CATEGORY = 'warehouse-category',
	INBOUND = 'inbound',
	INVENTORY = 'inventory',
	LABELING = 'labeling',
	MONITORING = 'monitoring',
}

export const createApiRoute = (module: ApiModule, ...rest: string[]) => {
	if (!rest.length) return ''
	return `${module}/api/${rest.join('/')}`
}

export enum EApiSortType {
	ASC = 'asc',
	DESC = 'desc',
}
